import { render, staticRenderFns } from "./ConfirmRegistrationDetails.vue?vue&type=template&id=75079648"
import script from "./ConfirmRegistrationDetails.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistrationDetails.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRegistrationDetails.vue?vue&type=style&index=0&id=75079648&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports